export const createInvoiceProjectTV = (invoice_projects) => {
  return (invoice_projects && invoice_projects.length > 0) ? invoice_projects.map (c => {
    return {
      text: c.invoice_project_name,
      value: c.invoice_project_id
    };
  }): [];
}